export default {
  id : 'ps.RoomOccupancyQueryHandler',
  matches : {
    objectType : 'room',
    client : 'ps.RoomOccupancyEvents'
  },
  handle( cxt ) {
    const { clientProps : { data } } = cxt

    return {
      where : [
        [ '$data/analyticsType', '=', 'occupancy' ],
        [ '$data/featureDevice/deviceId', 'IN', data.items?.map( item => item.id ) ]
      ],
      perPage : 1000
    }
  }
}
